import ActionState from 'app/enums/ActionState'

export default function(input){

    switch(input){

        case ActionState.PENDING: return 'notice';
        case ActionState.IN_PROCESS: return 'warning';
        case ActionState.RESOLVED: return 'highlight-2';
        case ActionState.CLOSED: return 'positive';
        case ActionState.ON_HOLD: return '';
        case ActionState.ACTION_PL: return '';
        default: return '';
    }
}